export interface IPaymentSummary {
    paymentId:number;
    systemReferenceNumber:string;
    paymentAmount: number;
    requestedAt:Date;
    decisionType:string;
    requestOriginType:string;
    reasonCode:string;
    paymentType:string;
    cardNumber:string;
    echeckAccountNumber:string;
}


export class PaymentSummary implements IPaymentSummary{
    paymentId:number;
    systemReferenceNumber:string;
    paymentAmount: number;
    requestedAt:Date;
    decisionType:string;
    requestOriginType:string;
    reasonCode:string;
    paymentType:string;
    cardNumber:string;
    echeckAccountNumber:string;
}

